"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileLayoutSectionEnum = void 0;
var ProfileLayoutSectionEnum;
(function (ProfileLayoutSectionEnum) {
    ProfileLayoutSectionEnum["Details"] = "details";
    ProfileLayoutSectionEnum["Bets"] = "bets";
    ProfileLayoutSectionEnum["Transactions"] = "transactions";
    ProfileLayoutSectionEnum["Messages"] = "messages";
    ProfileLayoutSectionEnum["Referral"] = "referral";
    ProfileLayoutSectionEnum["Promotions"] = "promotions";
    ProfileLayoutSectionEnum["Bonus"] = "bonus";
    ProfileLayoutSectionEnum["Agent"] = "agent";
    ProfileLayoutSectionEnum["Main"] = "main";
    ProfileLayoutSectionEnum["Wallet"] = "wallet";
    ProfileLayoutSectionEnum["ResponsibleGaming"] = "responsible_gaming";
    ProfileLayoutSectionEnum["GetBonusButton"] = "get_bonus_button";
    ProfileLayoutSectionEnum["Rules"] = "rules";
    ProfileLayoutSectionEnum["Sport"] = "sport";
    ProfileLayoutSectionEnum["Livecasino"] = "livecasino";
    ProfileLayoutSectionEnum["Slots"] = "slots";
    ProfileLayoutSectionEnum["Inbox"] = "inbox";
    ProfileLayoutSectionEnum["Sent"] = "sent";
    ProfileLayoutSectionEnum["Compose"] = "compose";
    ProfileLayoutSectionEnum["ChatService"] = "chat_service";
    ProfileLayoutSectionEnum["2FA"] = "2fa";
    ProfileLayoutSectionEnum["Crm"] = "crm_notifications";
    ProfileLayoutSectionEnum["Gamification"] = "gamification";
})(ProfileLayoutSectionEnum || (exports.ProfileLayoutSectionEnum = ProfileLayoutSectionEnum = {}));
//# sourceMappingURL=profile.js.map